











































































import Vue from "vue";
import ApiSearchPage from "@/components/apiSearch/components/ApiSearchPage.vue";
import IconButton from "@/components/IconButton.vue";
import SyncStatusBadge from "../SyncStatusBadge.vue";
import DateTimeDisplay from "@/components/DateTimeDisplay.vue";
import InvoiceInfo from "./InvoiceInfo.vue";
import SyncInvoiceItemEdit from "../syncEntityEdits/SyncInvoiceItemEdit.vue";
import { ColumnType } from "@/components/apiSearch/models/ApiSearch";
import { taxCodeAndName } from "../../models/IfaceSyncInvoiceItemDTO";
import eventBus from "@/services/eventBus";

interface Props {
  /** Az adott számlafej (mlsysisync_invhead.szam) — ehhez tartozó tételek kerülnek listázásra */
  headId: number;
  /** Csoportosító külső azonosító — csak megjelenítéshez a fejlécben */
  extCode: string;
  /** A szülő számlafej-rekord (opcionális). Ha meg van adva, tétel-szerkesztéskor a fejet is megjelöljük.
   *  Ezen tároljuk a `_cachedItems`-et is, hogy ne resetelődjön a tételek állapota csukás/nyitáskor. */
  head: any;
  /** Csak olvasható — ekkor a szerkesztő form minden mezője tiltva (pl. nem a legutolsó szinkron állapot). */
  readonly: boolean;
  /** A fejléc-összegző (invoice-info) megjelenjen-e a tétel lista felett. */
  showInfo: boolean;
}

interface Methods {
  toggleEdit(item: any): void;
  onItemSaved(item: any): void;
  cacheItems(items: any[]): void;
  /** Áfakulcs megjelenítés: "(külső kód) K2D megnevezés". */
  taxDisplay(item: any): string;
}

interface Computed {
  url: string;
  apiSearchName: string;
  columns: any[];
  hasCachedItems: boolean;
}

export default Vue.extend<{}, Methods, Computed, Props>({
  name: "InvoiceItems",

  components: {
    ApiSearchPage,
    IconButton,
    SyncStatusBadge,
    DateTimeDisplay,
    InvoiceInfo,
    SyncInvoiceItemEdit,
  },

  props: {
    headId: { type: Number, required: true },
    extCode: { type: String, default: "" },
    head: { type: Object, default: null },
    readonly: { type: Boolean, default: false },
    showInfo: { type: Boolean, default: true },
  },

  computed: {
    url(): string {
      return `iface-sync-invoice-item/search/${this.headId}`;
    },

    apiSearchName(): string {
      return `InvoiceItemsEditApiSearch_${this.headId}`;
    },

    /** Van-e már cache-elt tétel lista a head-en — ekkor nem töltünk újra. */
    hasCachedItems(): boolean {
      return !!this.head && Array.isArray(this.head._cachedItems);
    },

    columns(): any[] {
      return [
        { field: "command", title: "", cell: "command", filterable: false, sortable: false, width: 60 },
        { field: "id", title: "Azonosító", width: 80, cell: "disabledText" },
        { field: "itemName", title: "Megnevezés", cell: "editableText" },
        { field: "parts", title: "Cikk azonosító", width: 130, cell: "editableText" },
        { field: "gparts", title: "Egyéb cikk azonosító", width: 130, cell: "editableText" },
        { field: "quantity", title: "Mennyiség", width: 80, type: ColumnType.Right, filterable: false },
        { field: "unitType", title: "Egység", width: 80, cell: "editableText" },
        { field: "unitPrice", title: "Egységár (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "netto", title: "Nettó (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "vat", title: "Áfa (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "total", title: "Bruttó (HUF)", width: 110, type: ColumnType.Money, filterable: false },
        { field: "tax", title: "Áfa kód", width: 190, cell: "taxCode" },
        { field: "syncRemark", title: "Megjegyzés", width: 200, cell: "editableText" },
        { field: "errorText", title: "Hibaüzenet", width: 220, fieldClass:"error-text-col", cell: "disabledText" },
        { field: "syncStatusName", title: "Státusz", width: 140, cell: "syncStatusName" },
        { field: "updUserName", title: "Utoljára módosította", width: 130, cell: "disabledText" },
        { field: "updDateTime", title: "Utolsó szinkron ideje", width: 110, filterable: false, cell: "updDateTime" },
      ];
    },
  },

  mounted() {
    // Ha van cache-elt tétel lista a head-en, akkor az auto-load helyett azt töltjük be —
    // így a korábban szerkesztett tételek állapota (showItemEdit, userModified) megmarad újranyitáskor.
    if (this.hasCachedItems) {
      this.$nextTick(() => {
        eventBus.$emit(`${this.apiSearchName}:set-items`, this.head._cachedItems);
      });
    }
  },

  methods: {
    taxDisplay(item: any): string {
      return taxCodeAndName(item);
    },

    /** A részletes szerkesztő tab nyitása/csukása az adott tételen. */
    toggleEdit(item: any) {
      item.showItemEdit = !item.showItemEdit;
    },

    /**
     * Tétel mentése után (a SyncInvoiceItemEdit már beállította a userModified flaget):
     * a fejet is megjelöljük (userModified + selected — így a checkbox is kipipálódik a fő
     * listán), és becsukjuk a szerkesztő tabot.
     * TODO: backend update endpoint hívása.
     */
    onItemSaved(item: any) {
      if (this.head) {
        this.$set(this.head, "userModified", true);
        this.$set(this.head, "selected", true);
      }
      item.showItemEdit = false;
    },

    /**
     * Az ApiSearchPage által betöltött tétel lista cache-elése a fej-rekordon,
     * hogy a felhasználói módosítások (showItemEdit / userModified) megmaradjanak,
     * amikor a tétel táblát becsukjuk és újra megnyitjuk.
     */
    cacheItems(items: any[]) {
      if (this.head) {
        this.$set(this.head, "_cachedItems", items);
      }
    },
  },
});
